import { Subject, of } from 'rxjs'
import { takeUntil, catchError, switchMap } from 'rxjs/operators'

import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'

import { Site } from '../../../features/oee-dashboard/models/equipment.model'
import { OEEDataService } from '../../../features/oee-dashboard/services/oee-data.service'

@Component({
    selector: 'shared-site-selector',
    templateUrl: './site-selector.component.html',
    styleUrls: ['./site-selector.component.scss'],
    standalone: false
})
export class SiteSelectorComponent implements OnInit, OnDestroy {
    @Input() theme: 'light' | 'dark' = 'light'
    @Input() displayFormat: 'name' | 'name-code' = 'name'
    @Output() siteChange = new EventEmitter<string>()

    sites: Site[] = []
    selectedSiteId: string | null = null

    private destroy$ = new Subject<void>()

    constructor(
        private oeeDataService: OEEDataService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.oeeDataService.ensureSelectedSite().pipe(
            switchMap(() => this.oeeDataService.getSites()),
            takeUntil(this.destroy$),
            catchError(() => of([]))
        ).subscribe(sites => {
            this.sites = sites
            this.cdr.markForCheck()
        })

        this.oeeDataService.selectedSite$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(siteId => {
            this.selectedSiteId = siteId
            this.cdr.markForCheck()
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    onSiteChange(siteId: string): void {
        this.selectedSiteId = siteId
        this.oeeDataService.setSelectedSite(siteId)
        this.siteChange.emit(siteId)
    }

    displayName(site: Site): string {
        if (this.displayFormat === 'name-code') {
            return site.code ? site.name + ' (' + site.code + ')' : site.name
        }
        return site.name
    }
}
